import { baseConfig, RuntimeConfig } from 'config/config.types';
import { productionColor } from 'theme/palette';

export const config: RuntimeConfig = {
  ...baseConfig,
  env: 'local',
  bannerColour: productionColor,
};
